import { BlurFade } from '@/components/ui/blur-fade'
import { NumberTicker } from '@/components/ui/number-ticker'
import { PillButton } from './PillButton'

// TODO: pull these from the backend with a manual fallback (see plan §16).
const STATS = [
  { value: 3000, suffix: '+', label: 'members' },
  { value: 40, suffix: '+', label: 'facilitators' },
  { value: 200, suffix: '+', label: 'events run' },
]

const TESTIMONIALS = [
  {
    quote: 'I finally have a Sunday rhythm I keep returning to.',
    by: 'Priya, member',
  },
  {
    quote: 'It’s the only place I trust to find good facilitators in Bangalore.',
    by: 'Aman, member',
  },
  {
    quote: 'My team did Energizers and it changed how we work.',
    by: 'Founder, fintech startup',
  },
]

export function CommunitySection() {
  return (
    <section id="community" className="bg-primary-50/70">
      <div className="mx-auto max-w-[1100px] px-6 py-16 lg:px-20 lg:py-20">
        <BlurFade>
          <h2 className="text-center text-3xl font-bold text-gray-900 sm:text-4xl">
            A community for people learning to live well
          </h2>
        </BlurFade>

        {/* Stats */}
        <div className="mt-12 grid grid-cols-1 gap-8 sm:grid-cols-3">
          {STATS.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-5xl font-bold tabular-nums text-primary-700 sm:text-6xl">
                <NumberTicker value={stat.value} />
                {stat.suffix}
              </div>
              <div className="mt-2 text-sm uppercase tracking-wide text-gray-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <BlurFade key={t.by} delay={i * 0.08}>
              <figure className="h-full rounded-2xl border border-primary-100 bg-white p-6">
                <blockquote className="text-lg leading-relaxed text-gray-800">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-4 text-sm text-gray-600">
                  — {t.by}
                </figcaption>
              </figure>
            </BlurFade>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          {/* TODO: replace with real WhatsApp community invite link */}
          <PillButton href="#community" variant="primary" className="w-full sm:w-auto">
            Join the WhatsApp community →
          </PillButton>
        </div>
      </div>
    </section>
  )
}
